

export const settlementType = {
    PAYMENT_HELPER:0,
    PAYMAN:1,
    IVR:2,
    VIP:8,
    ALLOTMENT:3,
    COLLECTIVE_PAYMENT_HELPER:4,
    COLLECTIVE_DEDICATED:5,
    FINAL_PAYED:4,
    IVR_TO_WALLET:5,

}